exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-receipt-test{position:absolute !important;top:5% !important;left:11% !important}@media only screen and (max-width: 600px){.modal-content-receipt{width:85% !important;top:75% !important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/UI/Modal/modalReceiptTest.scss
// module id = 652
// module chunks = 5